import CheckoutItem from "./CheckoutItem";

const MobileCheckout = ({ items, cost, showImage = true, translateKey }) => {
    return (
        <div>
            {items.map((item) => (
                <CheckoutItem key={item.product.id + "_MobileCheckout"} item={item} showImage={showImage} translateKey={translateKey} />
            ))}
        </div>
    );
};

export default MobileCheckout;
